import React, { useState } from "react";
import RLELogo from "../../../app/logo/rle-icon-white.png";
import { StyledLogoBox, StyledLogoImg } from "./StyledLogoComp.partial";

interface DrawerLogoProps {
  logoPath?: string;
}

export const DrawerLogo: React.FC<DrawerLogoProps> = ({ logoPath }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <StyledLogoBox data-testid="drawer-logo-link">
      <StyledLogoImg
        src={logoPath || RLELogo}
        alt="logo"
        fadein={loaded}
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
      />
    </StyledLogoBox>
  );
};
